<template>
  <MaintenancePage />
</template>

<script setup>
import MaintenancePage from './components/MaintenancePage.vue'
</script>